import get from 'lodash/get';
import { format } from "date-fns";
import arabicStrings from "react-timeago/lib/language-strings/ar";
import buildFormatter from "react-timeago/lib/formatters/buildFormatter";
import canUseDom from '../utils/can-use-dom';

export function storyColor(config = {}, story = {}) {
  const sectionId = get(story, ["sections", 0, "id"]);
  const menu = get(config, ['layout', 'menu'], []);
  const menuItem = menu.find(menuItem => menuItem.type === 'section' && menuItem['item-id'] === sectionId);
  return get(menuItem, ["data", "color"], '#000000');
}

export function sectionPath(config, section) {
  const sectionPathOnId = id  => {
    const section = get(config, ['sections'], []).find(section => section.id === id);
    if(!section) return "";
    return section["parent-id"] ? `${sectionPathOnId(section["parent-id"])}/${section.slug}` : section.slug;
  };

  if(!section) return "";
  return sectionPathOnId(section.id);
}


export function getNumberOfStoriesToShow(numberOfStoriesToShow = 6) {
  if(canUseDom){
    return parseInt(numberOfStoriesToShow);
  }
  return 1;
}
 export function altTagOfHeroImages(story = {}){
    return story["hero-image-caption"] || story["headline"]
 }


export function overrideLayouts(config, collection) {
  const layouts = get(config, ['theme-attributes', 'override_layouts']);

  if(!layouts) {
    return collection;
  }

  return Object.assign({}, collection, {
    items: collection.items.map((item, index) => Object.assign({}, item, {
      'associated-metadata': Object.assign({}, item['associated-metadata'], layouts[index])
    }))
  })
}

export function formatter(value, unit, suffix, date, config = {}) {
  const showDateForUnits = ['day', 'week', 'month', 'year'];

  if(get(config, ['theme-attributes', 'lang']) === 'ar') {
    const _formatter =  buildFormatter(arabicStrings);
    return _formatter.apply(this, [value, unit, suffix, date]);
  }
  if(unit === 'hour' && value > 23 || showDateForUnits.indexOf(unit) !== -1) {
    return format(new Date(date), 'DD MMM, YYYY');
  }
  return `${value} ${unit} ${suffix}`;
}
